export default "__VITE_ASSET__BgyjV3xs__"